import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';

import { xMark } from "../../../theme/icons";
import { AppIcon, AppIconButton } from '../../../theme';

export const CustomTextCellEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const inputRef = useRef(null);

  // Expose methods to AG Grid
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value;
      },
      focus() {
        inputRef?.current?.focus();
      }
    };
  });

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const handleChange = (event) => {
    setValue(event.target.value);
    props?.onValueChange(event.target.value); // Notify AG Grid of value change
  };

  const handleClear = () => {
    setValue(''); // Clear the input value
    props?.onValueChange("");
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <input
        ref={inputRef}
        value={value}
        onChange={handleChange}
        style={{ flexGrow: 1 }}
        className='ag-input-field-input ag-text-field-input'
      />
      {!!value &&
        <AppIconButton
          aria-label="close"
          onClick={() => handleClear()}
          className='cell-editor-clear-button'
          disableRipple
        >
          <AppIcon icon={xMark} />
        </AppIconButton>
      }
    </div>
  );
});